import React from "react";
import { FloatingLabel, Form, Row } from "react-bootstrap";
import MyCollapse from "../Common/MyCollapse";
import MyIcon from "../Common/MyIcon";
import HelpButton from "../HelpContent/HelpButton";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";

const { countries, defaultCountry, defaultTZ } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;
export default function MyOrganisation({
  handleOrganisationDetailsChange,
  organisationDetails,
  errors,
}) {
  return (
    <div>
      {" "}
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
            <>
              <h5 className=" d-flex align-items-center">
                <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                <span className="ms-2">
                  <span className="fw-bold me-2"> My Organisation:</span>
                  <HelpButton helpKey="settings-organisation-settings-my-organisation" />

                  <div className="small text-secondary">
                    Manage organisation details
                  </div>
                </span>
              </h5>
            </>
          
      
          <hr className="my-3 text-secondary" />
          <Row>
            <div className="col-6">
              <FloatingLabel label="Contact Name:" className="mb-2">
                <Form.Control
                  name="customer_profiles.contact_name"
                  placeholder="Contact Name"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.contact_name}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="Contact Email:" className="mb-2">
                <Form.Control
                  type="email"
                  name="customer_profiles.email"
                  placeholder="Contact Email"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.email}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="Phone:" className="mb-2">
                <Form.Control
                  type="number"
                  onChange={handleOrganisationDetailsChange}
                  name="customer_profiles.phone"
                  placeholder="Phone"
                  value={organisationDetails.customer_profiles.phone}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="Company Name:" className="mb-2">
                <Form.Control
                  name="customers.name"
                  placeholder="customers"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customers.name}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="Address:" className="mb-2">
                <Form.Control
                  as="textarea"
                  name="customer_profiles.address"
                  placeholder="Address"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.address}
                />
              </FloatingLabel>

              {errors["customer_profiles.address"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.address"]}
                </div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="Postcode:" className="mb-2">
                <Form.Control
                  name="customer_profiles.postcode"
                  placeholder="Postcode"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.postcode}
                />
              </FloatingLabel>
              {errors["customer_profiles.postcode"] && (
                <div className="alert alert-danger">
                  {errors["customer_profiles.postcode"]}
                </div>
              )}
            </div>
            <div className="col-6">
              <FloatingLabel label="Registration Number:" className="mb-2">
                <Form.Control
                  type="number"
                  onChange={handleOrganisationDetailsChange}
                  placeholder="Registration Number"
                  name="customer_profiles.company_num"
                  value={organisationDetails.customer_profiles.company_num}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="VAT Number:" className="mb-2">
                <Form.Control
                  type="number"
                  onChange={handleOrganisationDetailsChange}
                  placeholder="VAT Number"
                  name="customer_profiles.vat_number"
                  value={organisationDetails.customer_profiles.vat_number}
                />
              </FloatingLabel>
            </div>
            <div className="col-6">
              <FloatingLabel label="Website:" className="mb-2">
                <Form.Control
                  name="customer_profiles.www"
                  placeholder="Website"
                  onChange={handleOrganisationDetailsChange}
                  value={organisationDetails.customer_profiles.www}
                />
              </FloatingLabel>
            </div>

            <div className="col-6">
              <div className="bg-white rounded-3 p-3">
                <div>Country:</div>{" "}
                <Input
                  inputType="select"
                  onChange={([v]) =>
                    handleOrganisationDetailsChange({
                      target: { name: "customer_profiles.country", value: v },
                    })
                  }
                  value={[organisationDetails.customer_profiles.country]}
                  options={countries.map((c) => ({
                    label: c.country_name,
                    value: c.country_code,
                  }))}
                />
              </div>
            </div>
            {/* <FloatingLabel label="Country:" className="mb-2">
            
            <Form.Select
            
            
            className="border-0"
            defaultValue="Choose..."
            name="customer_profiles.country"
            onChange={handleOrganisationDetailsChange}
            value={organisationDetails.customer_profiles.country}
            >
            {countries.map((c) => (
              <option value={c.country_code}>{c.country_name}</option>
              ))}
              </Form.Select>
              </FloatingLabel> */}
          </Row>
      </div>
    </div>
  );
}